import { Metric } from '../metric/metric';
import { BMEventsType } from '../types';
import type { InteractionPerformanceEventFactoryConfig } from './types';

export const interaction = (config: InteractionPerformanceEventFactoryConfig): Metric => {
	return new Metric({
		...config,
		type: BMEventsType.INLINE_RESULT,
	});
};
